import Layout from './Layout';

import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { styled } from '@stitches/configed';
import { Button, Form, Input } from 'antd';
import { ChangeEvent, useState } from 'react';
import CheckCircleIcon from '../Common/Icons/CheckCirleIcon';
import { Result } from '../Common/Result';
import { Title } from './Login';

const RowCheck = styled('div', {
  display: 'flex',
  alignItems: 'center',
  uGap: 4,
  svg: {
    color: '#D9DCE1',
  },
  variants: {
    passed: {
      true: {
        svg: {
          color: '#17AFA7',
        },
      },
    },
  },
});


type Props = {
  onFinish: (values: any) => Promise<{
    success?: boolean;
    errors?: { field: string; errors: string[] }[];
  }>;
  fullname?: string;
  onLogin: () => void;
};
const ChangeDefaultPassword = ({ onFinish, fullname, onLogin }: Props) => {
  const [showResult, setShowResult] = useState(true);
  const [form] = Form.useForm();
  const [isSubmiting, setIsSubmiting] = useState(false);

  const [isSixChar, setIsSixChar] = useState(false);
  const [isHasUppercase, setIsHasUppercase] = useState(false);
  const [isHasNumber, setIsHasNumber] = useState(false);
  const [isHasSpecialChar, setIsHasSpecicalChar] = useState(false);

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const password = e.target.value;
    if (password.length >= 6) {
      setIsSixChar(true);
    } else {
      setIsSixChar(false);
    }
    if (/[A-Z]/.test(password)) {
      setIsHasUppercase(true);
    } else {
      setIsHasUppercase(false);
    }
    /[0-9]/.test(password) ? setIsHasNumber(true) : setIsHasNumber(false);
    /[!@#$%^&*(),.?":{}|<>]/.test(password)
      ? setIsHasSpecicalChar(true)
      : setIsHasSpecicalChar(false);
  };

  if (showResult) {
    return (
      <Layout>
        <Result
          type="success"
          title="Thiết lập mật khẩu thành công"
          message={
            <span>
              YouGo cảm ơn và vinh dự khi có thêm bạn là đối tác nhà hàng mới.{' '}
              <br />
              Từ bây giờ bạn sẽ sử dụng email và mật khẩu mới để đăng nhập hệ
              thống.
            </span>
          }
        >
          <div style={{ width: '234px !important' }}>
            <Button block type="primary" onClick={onLogin}>
              Đăng nhập tài khoản
            </Button>
          </div>
        </Result>
      </Layout>
    );
  }

  return (
    <Layout>
      <Form
        layout="vertical"
        form={form}
        onFinish={async (value) => {
          setIsSubmiting(true);
          const res = await onFinish(value);
          if (res.success) {
            setShowResult(true);
          }
          if (res.errors) {
            const arr = res.errors.map((x) => {
              return {
                name: x.field,
                errors: x.errors,
              };
            });
            form.setFields(arr);
            form.scrollToField(arr[0].name);
          }
          setIsSubmiting(false);
        }}
        validateTrigger="onSubmit"
      >
        {/* <Title>Chào {fullname}</Title> */}
        <Title>Vui lòng đổi mật khẩu mới để tiếp tục sử dụng.</Title>

        <Form.Item
          label="Mật khẩu mới"
          name="newPassword"
          rules={[{ required: true, message: 'Vui lòng nhập mật khẩu mới!' }]}
        >
          <Input.Password
            placeholder="Nhập mật khẩu mới"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            onChange={handlePasswordChange}
          />
        </Form.Item>

        <Form.Item
          label="Xác nhận mật khẩu mới"
          name="passwordConfirmation"
          dependencies={['newPassword']}
          required
          rules={[
            {
              validator(_, value) {
                if (!value)
                  return Promise.reject(
                    new Error('Vui lòng nhập mật lại khẩu mới!'),
                  );

                if (form.getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Hai mật khẩu mà bạn đã nhập không khớp!'),
                );
              },
            },
          ]}
        >
          <Input.Password
            placeholder="Nhập mật lại khẩu mới"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item colon={false}>
          Mật khẩu có độ bảo mật cao, nên có:
          <RowCheck passed={isSixChar}>
            <CheckCircleIcon />
            <span>Ít nhất 6 kí tự</span>
          </RowCheck>
          <RowCheck passed={isHasUppercase}>
            <CheckCircleIcon />
            <span>Có ký tự viết hoa (từ A - Z)</span>
          </RowCheck>
          <RowCheck passed={isHasNumber}>
            <CheckCircleIcon />
            <span>Có ký tự số (từ 0 - 9)</span>
          </RowCheck>
          <RowCheck passed={isHasSpecialChar}>
            <CheckCircleIcon />
            <span>Có ký tự đặt biệt (? * @...)</span>
          </RowCheck>
        </Form.Item>

        <Form.Item>
          <Button loading={isSubmiting} block type="primary" htmlType="submit">
            Cập nhật
          </Button>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default ChangeDefaultPassword;
